import { PaymentTimelineStatusComponent } from '../../../data-grid/utility/payment-timeline-status/payment-timeline-status.component';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InvoiceService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { InvoiceOccurance, SubscriptionById } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { BehaviorSubject } from 'rxjs';
import { DataGridComponent, EmptyStateContainerComponent } from '@fitness-force/grid';
import { DateFormatedComponent} from '@fitness-force/grid-utility'
import { InvoicePaymentAmountComponent } from '../../../data-grid/utility/invoice-payment-amount/invoice-payment-amount.component';
import { TooltipModule } from 'primeng/tooltip';
import { PaymentDerivedStatus, RecurringOccuranceType } from '@fitness-force/enum';
import { TagModule } from 'primeng/tag';
import { StyleClassModule } from 'primeng/styleclass';
import { AppErrors } from 'libs/errors/src/lib/app.errors';
import { PaymentTimelineActionsComponent } from '@fitness-force/grid-utility/action';

@Component({
  selector: 'payment-timeline',
  templateUrl: './payment-timeline.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    DividerModule,
    TimelineModule,
    CurrencyformatPipe,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    DialogModule,
    DataGridComponent,
    TableModule,
    TooltipModule,
    StyleClassModule,
    TagModule,
    TranslateModule],
})
export class PaymentTimelineComponent implements OnInit {
  @Input('PaymentTimelineData') paymentTimelineData: InvoiceOccurance[] = [];
  @Input('subscription') subscription: SubscriptionById;
  currentDate: Date = new Date();
  paymentTimelineModal: boolean = false;
  timelineData$ = new BehaviorSubject<InvoiceOccurance[]>([]);
  filtetredTimelineData$ = new BehaviorSubject<InvoiceOccurance[]>([]);
  timelineDataTablecolumns$ = new BehaviorSubject<any>([]);
  selecall: boolean = false;
  emptyStateComponentForHistory$ = new BehaviorSubject<any>(EmptyStateContainerComponent);
  selectedTimeline:InvoiceOccurance;
  isbuttonclicked:boolean=false;

  constructor(public translate: TranslateService, private timeService: TimeconversionService, public cd: ChangeDetectorRef,
    private invoiceService: InvoiceService, private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    
    this.paymentTimelineData.forEach((o:InvoiceOccurance, index:number) => {
      o.occurance_start_date = this.timeService.ConvertUTCToLocalDateTime(o.occurance_start_date).toString();
    });
    const filteredOccurrences = this.filterOccurrencesByDate(this.paymentTimelineData);
    this.timelineData$.next(this.paymentTimelineData);
    this.filtetredTimelineData$.next(filteredOccurrences);
  }

  isDateStartingAfterToday(startDate: Date) {
    startDate = new Date(startDate);
    return startDate.getFullYear() > this.currentDate.getFullYear() &&
      startDate.getDate() > this.currentDate.getDate() &&
      startDate.getMonth() > this.currentDate.getMonth();
  }

  ShowTimelineData() {
    this.timelineData$.next(this.paymentTimelineData);
    this.TimelineColumnsTransalation();
    this.paymentTimelineModal = true;
    this.cd.detectChanges();
  }

  TimelineColumnsTransalation() {
    this.translate
      .get([
        'SUBSCRIPTIONS.PAYMENT_TIMELINE.DATE',
        'SUBSCRIPTIONS.PAYMENT_TIMELINE.AMOUNT',
        'SUBSCRIPTIONS.PAYMENT_TIMELINE.STATUS',
        'SUBSCRIPTIONS.PAYMENT_TIMELINE.FAILED_REASON'
      ])
      .subscribe((translations) => {
        this.GetTimelineColumns(translations);
      });
  }

  GetTimelineColumns(translations: any) {
    let columns = {
      Date: translations['SUBSCRIPTIONS.PAYMENT_TIMELINE.DATE'],
      Amount: translations['SUBSCRIPTIONS.PAYMENT_TIMELINE.AMOUNT'],
      Staus: translations['SUBSCRIPTIONS.PAYMENT_TIMELINE.STATUS'],
      Reason : translations['SUBSCRIPTIONS.PAYMENT_TIMELINE.FAILED_REASON']
    };
    this.timelineDataTablecolumns$.next([
      {
        title: columns.Date,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'occurance_start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'occurance_start_date', format: 'defaultformat' },
        },
      },
      {
        title: columns.Amount,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'payment_amount_in_minor_currency',
        type: 'component',
        data: {
          name: InvoicePaymentAmountComponent,
          fetch_key: 'payment_amount_in_minor_currency',
        },
      },
      {
        title: columns.Staus,
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'payment_status',
        type: 'component',
        data: {
          name: PaymentTimelineStatusComponent
        }
      },
      {
        title: columns.Reason,
        classes: 'py-3 text-600 w-15rem white-space-wrapper',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'failed_reason',
        type: 'default'
      },
      {
        title: "",
        classes: ' py-3 text-600 w-15rem white-space-nowrap',
        dataProperty: 'actions',
        type: 'component',
        data: {
          name: PaymentTimelineActionsComponent,
          additionData: true,
          aData: [
            'retrypayment'
          ],
        },
      }

    ]);
  }

  onActionEvent(event: any) {
    switch (event.action) {
      case 'retrypayment':
        {
          this.selectedTimeline = event.columnData;
          this.retryPayment();
        }
        break;
    }
  }

  callRetryPayment(timeline: InvoiceOccurance) {
    this.selectedTimeline = timeline;
    this.retryPayment();
  }

  retryPayment() {
    this.isbuttonclicked=true;
    this.invoiceService.RetryFailedPayment(this.selectedTimeline.occurance_tenant_id, this.selectedTimeline.occurance_client_id, this.selectedTimeline.occurance_invoice_id).subscribe({
      next: (data: any) => {
        this.translate
          .get('SUBSCRIPTIONS.PAYMENT_TIMELINE.RETRY_MSG')
          .subscribe((translation) => {
            this.toastService.showSuccess(translation);
          });
          this.isbuttonclicked=false;
          this.cd.detectChanges();  
      },
      error: (error: AppErrors) => {
          this.isbuttonclicked=false;
          this.toastService.showError(error);
          this.cd.detectChanges();  
      },
    });
  }

  get PaymentTimeline()
  {
    return new BehaviorSubject(this.paymentTimelineData);
  }

  public get paymentStatus()
  {
    return PaymentDerivedStatus;
  }

  public get recurringOccuranceType()
  {
    return RecurringOccuranceType;
  }

  // Function to filter occurrences within the previous 3 months and next 5 months
  filterOccurrencesByDate(occurrences: InvoiceOccurance[]): InvoiceOccurance[] {
    const currentDate = new Date();

    // Calculate the start date of the previous 3 months
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

    // Calculate the end date of the next 5 months
    const fiveMonthsLater = new Date();
    fiveMonthsLater.setMonth(currentDate.getMonth() + 5);

    // Filter occurrences based on the date range
    const filteredOccurrences = occurrences.filter(occurrence => {
      const startDate = new Date(occurrence.occurance_start_date);
      return startDate >= threeMonthsAgo && startDate <= fiveMonthsLater;
    });

    return filteredOccurrences;
  }

  getTooltipMessage(OcurenctType:InvoiceOccurance)
  {
    let message:string="";
    var data = RecurringOccuranceType[OcurenctType.occurance_type.toString() as keyof typeof RecurringOccuranceType]
    switch (data) {
      case RecurringOccuranceType.Deposit:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.EndProrata:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.Freeze:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.InitialProRata:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        
        break;
      case RecurringOccuranceType.MiddCycleAddon:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.MID_CYCLE_ADDON_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.MiddCycleDiscount:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.MID_CYCLE_DIS_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      case RecurringOccuranceType.Recurring:
        this.translate.get('SUBSCRIPTIONS.PAYMENT_TIMELINE.ERROR_MSG')
        .subscribe((translations: any) => {
          message = translations;
        });
        break;
      }
    return message;
  }

  isSuccessfulPayment(timeline: InvoiceOccurance): boolean {
    return timeline.payment_status === this.paymentStatus.Successfull ||
      timeline.payment_status!.toString() === this.paymentStatus[this.paymentStatus.Successfull];
  }

  isfailedPayment(timeline: InvoiceOccurance): boolean {
    return timeline.payment_status === this.paymentStatus.Failed ||
      timeline.payment_status!.toString() === this.paymentStatus[this.paymentStatus.Failed];
  }

  isOccurenceDiscount(timeline: InvoiceOccurance): boolean {
    return timeline.occurance_type === this.recurringOccuranceType.MiddCycleDiscount ||
      timeline.occurance_type!.toString() === this.recurringOccuranceType[this.recurringOccuranceType.MiddCycleDiscount];
  }

  isInitialFailedPayment(timeline: InvoiceOccurance): boolean {
    return (timeline.occurance_type != RecurringOccuranceType.Recurring || timeline.occurance_type.toString() != RecurringOccuranceType[RecurringOccuranceType.Recurring])
    && (timeline.occurance_type != RecurringOccuranceType.InitialFullRecurring || timeline.occurance_type.toString() != RecurringOccuranceType[RecurringOccuranceType.InitialFullRecurring])
    && (timeline.payment_status !== PaymentDerivedStatus.Failed || timeline.payment_status.toString() !== PaymentDerivedStatus[PaymentDerivedStatus.Failed])
  }

  isFailedPaymentWithRecurring(timeline: InvoiceOccurance): boolean {
    return (timeline.payment_status === this.paymentStatus.Failed ||
      timeline.payment_status!.toString() === this.paymentStatus[this.paymentStatus.Failed]) && timeline.occurance !== 1;
  }

  shouldShowIcon(timeline: any): boolean {
    let result:boolean=false;
    var data = RecurringOccuranceType[timeline.occurance_type.toString() as keyof typeof RecurringOccuranceType]
    switch (data) {
      case RecurringOccuranceType.Deposit:
       result= true;
        break;
      case RecurringOccuranceType.EndProrata:
        result= false;

        break;
      case RecurringOccuranceType.Freeze:
        result= true;
        break;
      case RecurringOccuranceType.InitialProRata:
        result= false;
        break;
      case RecurringOccuranceType.MiddCycleAddon:
        result= true;
        break;
      case RecurringOccuranceType.MiddCycleDiscount:
        result= true;
        break;
      case RecurringOccuranceType.Recurring:
        result= false;
        break;
      }
    return result;
  }

  shouldDisplayDepositTag(item: InvoiceOccurance): boolean {
    // Check if the current item is the start of a sequence
    return this.isStartOfSequence(item);
  }

  private isStartOfSequence(item: InvoiceOccurance): boolean {
    const currentIndex = this.filtetredTimelineData$.value.indexOf(item);

    // Check if the current item is the first in the array
    if (currentIndex === 0) {
      return true;
    }
    // Check if the current item has a different isDeposit value than the previous item
    const previousItem = this.filtetredTimelineData$.value[currentIndex - 1];
    return item.occurance_type !== previousItem.occurance_type;
  }

}